import apiClient from '@utils/apiClient.ts';
import { MenuResponse } from './type.ts';

export const menuApi = {
    getMenuList: async (): Promise<MenuResponse> => {
        const response = await apiClient.get<MenuResponse>('/api/v1/menu');
        return response.data;
    },
};
